module.exports = __webpack_public_path__ + "media/images/undraw/matching/notify-881e60635d03e931a77f1e7a0b0ac5f0.png";